export default {
  title: 'Apps',
  fields: {
    id: 'ID',
    name: 'Name',
    app_bundle_identifier: 'App Bundle ID',
    released: 'Released',
    franchise: 'Brand',
    app_icon: 'App Icon',
    status: 'Status',
    play_store_link: 'Play Store Link',
    apple_store_link: 'Apple Store Link',
    dynamic_link: 'Dynamic Link - QR Codes',
  },
  filters: {
    name: 'Name',
    released: 'Released',
  },
  columns: {
    backlog: '📋 Backlog',
    ready_to_build: '🛠️ Ready to Build',
    in_work: '🔧 In Work',
    in_review: '📝 In Review',
    rejected: '❌ Rejected',
    released: '✅ Released',
    deactivated: '🛑 Deactivated',
  },
  card: {
    overdue: 'Overdue · {{time}}',
    copied: 'Copied to clipboard',
    released_tag: {
      both: '✅ Released',
      ios: 'iOS Released',
      android: 'Android Released',
    },
    tags: {
      has_tech_issue: 'Tech issue',
    },
  },
  status_modal: {
    title: 'Update release status',
    status_label: 'Status',
    note_label: 'Note (optional)',
    note_placeholder: 'Add an optional note for this status change',
    tech_issue_checkbox: 'There is a technical issue',
    save: 'Save',
    cancel: 'Cancel',
  },
  released: {
    yes: 'Yes',
    no: 'No',
  },
  configured_status: {
    true: 'Yes',
    false: 'No',
  },
  delete_confirmation: {
    title: 'Delete Mobile App',
    message: 'Are you sure you want to delete this mobile app?',
    buttons: {
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
  },
};
